var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{ 'error--text': (_vm.value || 0) < 0, 'font-weight-bold': _vm.strong },domProps:{"textContent":_vm._s(_vm.currency(_vm.value, true))}})
}
var staticRenderFns = []

export { render, staticRenderFns }